<template>
  <ion-card data-test="preview-card-skeleton">
    <ion-card-header>
      <ion-card-title>
        <ion-skeleton-text
          data-test="title"
          style="width: 50%; height: 22px"
          :animated="true"
        ></ion-skeleton-text
      ></ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <ion-skeleton-text
        data-test="metadata"
        class="metadata"
        :animated="true"
        style="width: 30%; height: 16px"
      ></ion-skeleton-text>
      <ion-skeleton-text
        data-test="metadata"
        class="metadata"
        :animated="true"
        style="width: 30%; height: 16px"
      ></ion-skeleton-text>
      <div class="description-wrapper">
        <ion-skeleton-text
          data-test="description"
          class="description"
          :animated="true"
          style="width: 90%; height: 14px"
        ></ion-skeleton-text>
        <ion-skeleton-text
          data-test="description"
          class="description"
          :animated="true"
          style="width: 90%; height: 14px"
        ></ion-skeleton-text>
        <ion-skeleton-text
          data-test="description"
          class="description"
          :animated="true"
          style="width: 90%; height: 14px"
        ></ion-skeleton-text>
        <ion-skeleton-text
          data-test="description"
          class="description"
          :animated="true"
          style="width: 20%; height: 14px"
        ></ion-skeleton-text>
      </div>
    </ion-card-content>
    <div class="button">
      <ion-skeleton-text
        data-test="button"
        :animated="true"
        style="width: 40%; height: 30px"
      ></ion-skeleton-text>
    </div>
  </ion-card>
</template>

<script setup lang="ts">
import {
  IonCard,
  IonCardHeader,
  IonCardContent,
  IonSkeletonText,
} from "@ionic/vue";
</script>

<style lang="scss" scoped>
ion-card {
  -webkit-box-shadow: none;
  align-items: flex-start;
  background-color: var(--background-white);
  border-radius: 24px;
  border: 2px solid var(--light-grey-border);
  box-shadow: none;
  display: flex;
  flex-direction: column;
  margin: var(--spacing-0);
  max-height: 290px;
  max-width: 584px;
  min-height: 202px;
  padding: var(--spacing-24);
}

ion-card-header {
  padding: var(--spacing-0);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: var(--spacing-8);
  width: 100%;
}

ion-card-title {
  width: 90%;
}
ion-card-content {
  padding: var(--spacing-0);
  width: 100%;
  .metadata {
    line-height: 24px;
    margin-bottom: var(--spacing-0);
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .description-wrapper {
    margin-top: var(--spacing-8);
    margin-bottom: var(--spacing-16);
  }
  .description {
    display: -webkit-box;
    height: 100px;
    line-height: 20px;
  }
}

.button {
  width: 100%;
  margin-top: auto;
  border-radius: 8px;
}
</style>
